import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import FormikButton from '../../../components/formik/FormikButton';
import FormikInput from '../../../components/formik/FormikInput';
import Form from '../../../components/utilities/Form';

export default function Payment({ onPayment, amountToPay, isLoading }) {
    return (
        <Container maxWidth="sm">
            <Box sx={{ my: 1 }}>
                <Typography>
                    Congratulations, you are all done! Activate your myKanisa
                    account by making a payment of{' '}
                    <span className="text-success fw-bold">
                        {'KSH ' + amountToPay}
                    </span>
                </Typography>
            </Box>
            <Form onSubmit={onPayment} initialValues={{ promo: '' }}>
                <FormikInput name="promo" label="Enter Promo Code" />
                <Typography sx={{ my: 1 }}>
                    Click pay now if you have no promo code.
                </Typography>
                <FormikButton loading={isLoading} variant="contained" fullWidth>
                    Pay Now
                </FormikButton>
            </Form>
        </Container>
    );
}
